module.exports = __webpack_public_path__ + "static/HeadzUP-manual-A4-min-5eefeacd0ff16c786c066e657cb00fcb.pdf";